import React from "react";

type HttpLogProps = {
  size?: string;
};

const HttpLog = ({ size = "32px" }: HttpLogProps) => {
  const stroke = "var(--icon-ebony-light-color,var(--ebony-light))";
  const fill = stroke;
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size }}
    >
      <circle cx="11" cy="13.5911" r="1" fill={fill} />
      <circle cx="11" cy="17.5911" r="1" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0082 21.8499C17.4747 21.7069 17.1581 21.1586 17.3011 20.6251L19.8892 10.9659C20.0322 10.4324 20.5805 10.1158 21.114 10.2588C21.6475 10.4017 21.964 10.9501 21.8211 11.4835L19.2329 21.1428C19.09 21.6762 18.5416 21.9928 18.0082 21.8499Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8856 21.8499C13.3521 21.7069 13.0356 21.1586 13.1785 20.6251L15.7667 10.9659C15.9096 10.4324 16.458 10.1158 16.9914 10.2588C17.5249 10.4017 17.8415 10.9501 17.6985 11.4835L15.1103 21.1428C14.9674 21.6762 14.4191 21.9928 13.8856 21.8499Z"
        fill={fill}
      />
      <rect
        x="5"
        y="5"
        width="22"
        height="22"
        rx="3"
        stroke={stroke}
        strokeWidth="2"
      />
    </svg>
  );
};
export default HttpLog;
